import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Provider } from "react-redux";
import Store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
// import CheckUserActivity from "./custom/checkUserActivity";



ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <Provider store={Store}>
            <App />
        </Provider>
    </BrowserRouter>
);

